// Module to manage the strings

import _EN from '../strings/en';
import _DE from '../strings/de';
import _TE from '../strings/te';
import _BRANDING from '../strings/branding';

const langs = {
 "en": Object.assign({},_EN,_BRANDING),
 "de": Object.assign({},_DE,_BRANDING),
 "te": Object.assign({},_TE,_BRANDING)
};

let lang = "en";
let strings = Object.assign({},langs[lang]);

export function set_lang(l) {
 if(langs[l]) Object.assign(strings,langs[l]);
 else console.error("set_lang: language " + l+ " is not supported!");
}

export default strings;
